import React, { Component } from 'react'
import {
    Link,
    browserHistory,
    Redirect
} from 'react-router-dom'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import { FormattedMessage, FormattedHTMLMessage, injectIntl, defineMessages } from 'react-intl'
import $ from 'jquery'
import ProductSelect from "../../common/product-selection/selection.component.jsx"
import ConfirmButton from "../../common/button/confirmbutton.component.jsx"

class RelationshipEditForm extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            id: '',
            description: '',
            type: 'recommend',
            objectProductId: '',
            objectProductTitle: '',
            subjectProductId: '',
            subjectProductTitle: '',
            formStatus: '',
            deleteButton: '',
        }

        this.submitProduct = this.submitProduct.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
        this.deleteRelationship = this.deleteRelationship.bind(this)
        this.chooseProductSubject = this.chooseProductSubject.bind(this)
        this.chooseProductObject = this.chooseProductObject.bind(this)
        this.openProductSubjectSelector = this.openProductSubjectSelector.bind(this)
        this.openProductObjectSelector = this.openProductObjectSelector.bind(this)
    }

    componentDidMount() {
        const relationship = this.props.relationship
        if (relationship && relationship.id) {
            const deleteButton = <ConfirmButton identifier={relationship.attributes.description} onClick={this.deleteRelationship} className="btn btn-danger">
                <FormattedMessage
                    id="relationship.form.edit.delete_btn"
                    defaultMessage="Delete relationship"
                />
            </ConfirmButton>
            this.setState({
                id: relationship.id,
                description: relationship.attributes.description,
                type: relationship.attributes.type,
                deleteButton: deleteButton,
                subjectProductId: relationship.attributes.subjectProductId,
                objectProductId: relationship.attributes.objectProductId,
            })
        }

    }

    deleteRelationship(event) {
        const relationship = this.props.relationship
        AppContext.getApiClient().delete('/relationships/' + relationship.id).then((response) => {
            let formStatus = ''
            if (!response.error) {
                formStatus = <Redirect
                    to={{
                        pathname: '/relationships/listing'
                    }}
                />
            }
            this.setState({ formStatus: formStatus })
        })

        event.preventDefault()
    }

    saveProduct() {
        const relationship = this.props.relationship
        if (relationship && relationship.id) {
            let updates = {}
            const allowedFields = [
                "description",
                "objectProductId",
                "subjectProductId",
                "type",
            ]
            for (let i = 0; i < allowedFields.length; i++) {
                let field = allowedFields[i]
                if (relationship.attributes[field] != this.state[field]) {
                    updates[field] = this.state[field]
                }
            }
            return AppContext.getApiClient().patch('/relationships/' + relationship.id, updates)
        } else {
            return AppContext.getApiClient().post('/relationships', {
                "description": this.state.description,
                "objectProductId": this.state.objectProductId,
                "subjectProductId": this.state.subjectProductId,
                "type": this.state.type,
            })
        }
    }

    submitProduct(event) {
        this.saveProduct().then((response) => {
            let formStatus = ''
            if (!response.error) {
                formStatus = <Redirect
                    to={{
                        pathname: '/relationships/listing'
                    }}
                />
            }
            this.setState({ formStatus: formStatus })
        })

        event.preventDefault()
    }

    handleFormChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    chooseProductSubject(productId) {
        this.setState({
            subjectProductId: productId,
        })
    }

    openProductSubjectSelector(event) {
        $('#subjectSelector').modal('show')
        event.preventDefault()
    }

    chooseProductObject(productId) {
        this.setState({
            objectProductId: productId,
        })
    }

    openProductObjectSelector(event) {
        $('#objectSelector').modal('show')
        event.preventDefault()
    }

    render() {
        const messages = defineMessages({
            "relationship.form.edit.description_placeholder": {
                id: 'relationship.form.edit.description_placeholder',
                defaultMessage: 'Description of the relationship',
            },
            "relationship.form.edit.save_btn": {
                id: 'relationship.form.edit.save_btn',
                defaultMessage: 'Create relation',
            },
            "relationship.form.edit.type_recommend_label": {
                id: 'relationship.form.edit.type_recommend_label',
                defaultMessage: 'Recommended with',
            },
            "relationship.form.edit.type_incompatible_label": {
                id: 'relationship.form.edit.type_incompatible_label',
                defaultMessage: 'Incompatible with',
            },
        })

        return (
            <form onSubmit={this.submitProduct}>
                <div className="row ui-has-modules">
                    <div className="col-12 ui-module">
                        <div className="form-group row">
                            <label className="col-2 col-form-label text-align-right" htmlFor="relationshipDescription">
                                <FormattedMessage
                                    id="relationship.form.edit.description_label"
                                    defaultMessage="Description"
                                />
                            </label>
                            <div className="col-10">
                                <input
                                    name="description"
                                    value={this.state.description}
                                    onChange={this.handleFormChange}
                                    id="relationshipDescription"
                                    type="text"
                                    className="form-control"
                                    placeholder={this.props.intl.formatMessage(messages['relationship.form.edit.description_placeholder'])}
                                />
                                <small className="form-text text-muted">
                                    <FormattedMessage
                                        id="relationship.form.edit.description_description"
                                        defaultMessage="Describe the relationship in a few words"
                                    />
                                </small>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-2 col-form-label text-align-right" htmlFor="relationshipSubject">
                                <FormattedMessage
                                    id="relationship.form.edit.subject_label"
                                    defaultMessage="Subject"
                                />
                            </label>
                            <div className="col-10 col-form-label">
                                <ProductSelect types={['assembly', 'matrix-parent', 'matrix-item', 'single']} value={this.state.subjectProductId} onChange={this.chooseProductSubject} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-2 col-form-label text-align-right" htmlFor="productType">
                                <FormattedMessage
                                    id="relationship.form.edit.type_label"
                                    defaultMessage="Type"
                                />
                            </label>
                            <div className="col-10">
                                <select
                                    name="type"
                                    value={this.state.type}
                                    onChange={this.handleFormChange}
                                    id="productType"
                                    className="form-control"
                                >
                                    <option value="recommend">
                                        {this.props.intl.formatMessage(messages['relationship.form.edit.type_recommend_label'])}
                                    </option>
                                    <option value="incompatible">
                                        {this.props.intl.formatMessage(messages['relationship.form.edit.type_incompatible_label'])}
                                    </option>
                                </select>
                                <small className="form-text text-muted">
                                    <FormattedHTMLMessage
                                        id="relationship.form.edit.type_recommend_description"
                                        defaultMessage="<b>Recommend with</b> generates a recommendation when creating a quote"
                                    />
                                    <br />
                                    <FormattedHTMLMessage
                                        id="relationship.form.edit.type_incompatible_description"
                                        defaultMessage="<b>Incompatible with</b> generate a warning when creating a quote"
                                    />
                                </small>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-2 col-form-label text-align-right" htmlFor="relationshipObject">
                                <FormattedMessage
                                    id="relationship.form.edit.object_label"
                                    defaultMessage="Object"
                                />
                            </label>
                            <div className="col-10 col-form-label">
                                <ProductSelect types={['assembly', 'matrix-parent', 'matrix-item', 'single']} value={this.state.objectProductId} onChange={this.chooseProductObject} />
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        {this.state.formStatus}
                    </div>
                    <div className="col-12 ui-module">
                        <div className="row">
                            <div className="col-6">
                                {this.state.deleteButton}
                            </div>
                            <div className="col-6 text-align-right">
                                <Link to="/relationships/listing" className="btn btn-light">
                                    <FormattedMessage
                                        id="relationship.form.edit.cancel_btn"
                                        defaultMessage="Cancel"
                                    />
                                </Link>
                                &nbsp;
                                &nbsp;
                                <input type="submit" value={this.props.intl.formatMessage(messages['relationship.form.edit.save_btn'])} className="btn btn-primary" />
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default injectIntl(RelationshipEditForm)


// WEBPACK FOOTER //
// ./src/relationship/form/edit.component.jsx